/* 设计部统一时间口径：一律按美国太平洋时间（America/Los_Angeles）显示与输入。
 *
 * 【需求背景 · 2026-10-29】
 * 用户原话：「之前做了一套国内外时间转换，两边分别看时间……今天统一了一下口径，
 * 全部统一按照美国时间走，显示-输入，不管是中文模式还是英文模式下」。
 *
 * 也就是说这里要同时满足两件事：
 *   ① 同一条记录，中国同事和美国同事看到的日期/时间必须完全一样（都是美国时间）；
 *   ② 中文界面和英文界面下，日期文本也必须完全一样（不随 locale 变形）。
 *
 * 【为什么单独一层，而不是改 lib/date.js】
 * lib/date.js 是全局共享的，HRMS（中国主体）、财务、行政审批、Usage Analytics
 * 等模块确实按各自时区运营，跟着改成美国时间会把那些业务算错。所以那边保持不变，
 * 这里用 makeDateFmt 造一份固定洛杉矶的实例，只有设计部模块 import 这一层。
 *
 * 【与后端的关系】
 * 后端设计模块的 PROJECT_TZ 就是 America/Los_Angeles（design_module.py），
 * 阶段链、逾期天数、承诺日剩余天数早已按洛杉矶日历日计算；本轮把前端显示/输入
 * 也钉到同一时区，前后端才真正是「一套钟」。
 */
import { makeDateFmt, todayIn, dayStartIsoIn } from "./date";

/** 设计部统一时区：洛杉矶（含夏令时 PST/PDT），与后端 PROJECT_TZ 同源 */
export const US_TZ = "America/Los_Angeles";

const us = makeDateFmt(US_TZ);

/** 带时区的瞬间按洛杉矶换算后的 YYYY-MM-DD（日期输入框初始值、原生 date 控件值） */
export const dateInputValue = us.dateInputValue;
/** MM/DD/YYYY（洛杉矶日历日） */
export const fmtD = us.fmtD;
/** MM/DD/YYYY HH:mm（洛杉矶，24 小时制） */
export const fmtDT = us.fmtDT;
/** MM/DD（洛杉矶日历日） */
export const fmtMD = us.fmtMD;
/** HH:mm（洛杉矶，24 小时制） */
export const fmtT = us.fmtT;
/** 自由文本里的 ISO 日期就地换成本格式（仍按洛杉矶换算） */
export const fmtText = us.fmtText;
/** 日期区间 */
export const fmtRange = us.fmtRange;

/** 洛杉矶的「今天」：YYYY-MM-DD。用于逾期判定、日期控件的 min/max、默认截止日。 */
export const usToday = () => todayIn(US_TZ);

/**
 * 用户选的「美国日历日」→ 洛杉矶当天 00:00 的 UTC 瞬间。
 * 改期、预约这类要落库成瞬间的字段都用它，保证任何人回看都是同一天。
 */
export const usDayStartIso = (ymd) => dayStartIsoIn(ymd, US_TZ);
